jQuery(function ($) {

    // ------------------------------------------------------------
    //  GLOBAL INITIALISATIONS
    // ------------------------------------------------------------

    $('[data-bs-toggle="tooltip"]').tooltip();

    // Reset forms when modals close
    function registerModalReset(modalId, formId) {
        $(modalId).on('hidden.bs.modal', function () {
            $(formId)[0]?.reset();
        });
    }

    registerModalReset('#dwenquiry', '#DWEnquiryForm');
    registerModalReset('#packageEnquiry', '#PackageEnquiryForm');

    // Wrap Contact Form 7 spinner
    $('.wpcf7-spinner').each(function () {
        if (!$(this).parent().hasClass('wpcf7-spinner-wrapper')) {
            $(this).wrap('<div class="wpcf7-spinner-wrapper"></div>');
        }
    });

    // Toggle button groups
    $('.btn-group-toggle label').on('click', function () {
        $(this).addClass('active')
               .siblings().removeClass('active');
    });

    // ------------------------------------------------------------
    //  POPULATE CF7 LOCATION TERMS
    // ------------------------------------------------------------
    (function initLocationTerms() {
        const $container = $('#location-terms');
        const $dropdown = $('select[name="location_dropdown"]');
        if (!$container.length || !$dropdown.length) return;

        $container.find('span').each(function () {
            const $term = $(this);

            const option = $('<option>', {
                value: $term.data('value'),
                text: $term.text(),
                selected: $term.data('selected-slug') === $term.data('value')
            });

            $dropdown.append(option);
        });
    })();

    // ------------------------------------------------------------
    //  HANDLE CF7 ERROR TIP DUPLICATION
    // ------------------------------------------------------------
    $('.wpcf7-form-control-wrap .wpcf7-not-valid-tip').each(function () {
        const $tip = $(this);
        if ($tip.data('validated') !== 'true') {
            $tip.show().data('validated', 'true');
        } else {
            $tip.hide();
        }
    });

    // ------------------------------------------------------------
    //  SEARCH KEYWORDS (BLOG SEARCH)
    // ------------------------------------------------------------
    if ($('#s-1').length) {
        $('.ew-keyword').on('click', function (e) {
            e.preventDefault();
            $('#s-1').val($(this).text());
            $('#articleSearch').submit();
        });
    }

    // ------------------------------------------------------------
    //  PAGE: GUEST ACCOMMODATION
    // ------------------------------------------------------------
    if ($('body').hasClass('page-template-page-guest-accommodation')) {

        // Accordion active class toggle
        $('.accordion')
            .on('show.bs.collapse', e => $(e.target).closest('.accordion-item').addClass('active-accordion'))
            .on('hide.bs.collapse', e => $(e.target).closest('.accordion-item').removeClass('active-accordion'));

        // Image switching
        $(".img-accordion img").hide();
        $("#collapseOneImg").show();

        $(".accordion-button").on("click", function () {
            const imgId = $(this).attr("data-bs-target") + "Img";
            $(".img-accordion img").hide();
            $(imgId).fadeIn();
        });
    }

    // ------------------------------------------------------------
    //  PAGE: SINGLE PACKAGE
    // ------------------------------------------------------------
    if ($('body').hasClass('single-package')) {

        var $highlights = $('#mobileScrollPoint');
        var $contactForm = $('#contactForm');
        var $mobileContact = $('#mobileContact');

        $(window).on('scroll', function () {
            var scrollTop = $(window).scrollTop();
            var windowHeight = $(window).height();

            var highlightsBottom = $highlights.offset().top + $highlights.outerHeight();

            // Contact form viewport test
            var formTop = $contactForm.offset().top;
            var formBottom = formTop + $contactForm.outerHeight();

            var formInView = formBottom > scrollTop && formTop < scrollTop + windowHeight;

            // Main logic
            if (formInView) {
                // Hide if contact form is visible
                $mobileContact.fadeOut();
            } else if (scrollTop > highlightsBottom) {
                // Only show if scrolled past highlight AND contact form not in view
                $mobileContact.fadeIn();
            } else {
                $mobileContact.fadeOut();
            }
        });

        // Read More (package description)
        $(".readmore-link").on("click", function (e) {
            const $btn = $(e.target);
            const isExpanded = $btn.hasClass("expand");

            $(".package-description").removeClass("expand");
            $(".readmore-link").removeClass("expand")
                .html("Read More <i class='fa-light fa-chevron-down text-secondary ms-2'></i>");

            if (!isExpanded) {
                $(".package-description").addClass("expand");
                $btn.addClass("expand")
                    .html("Read Less <i class='fa-light fa-chevron-up text-secondary ms-2'></i>");
            }
        });

        // Truncate text blocks
        $(".line-clamp-4").each(function () {
            const $el = $(this);
            const full = $el.text().trim();
            if (full.length > 170) {
                $el.data("full-text", full)
                   .text(full.substring(0, 170) + "...")
                   .after('<span class="guest-read-more">read more</span>');
            }
        });

        // Resort read-more blocks
        $('.read-more-wrapper').each(function () {
            const $wrapper = $(this);
            const $content = $wrapper.find('.resort-read-more');
            const $btn = $wrapper.find('.read-more-btn');

            setTimeout(() => {
                const lh = parseFloat($content.css('line-height')) || 20;
                const maxH = lh * 10;

                const actual = $content.css('height', 'auto').outerHeight();
                $content.css('height', '');

                if (actual > maxH) {
                    $content.css('max-height', maxH);
                    $btn.show();
                }
            }, 100);

            $btn.on('click', function () {
                const expanded = $content.toggleClass('expanded').hasClass('expanded');
                $content.css('max-height', expanded ? 'none' : (parseFloat($content.css('line-height')) * 10));
                $(this).html(expanded
                    ? 'Read Less <i class="fa-light fa-chevron-up text-secondary ms-2"></i>'
                    : 'Read More <i class="fa-light fa-chevron-down text-secondary ms-2"></i>'
                );
            });
        });

        // Hero background slider
        (function initHeroSlider() {
            if (typeof images === 'undefined') return;

            let currentIndex = 0;
            const total = images.length;
            const $slider = $('#heroSlider');
            let autoSlide;

            // Create slide background
            function createSlideBackground(url, isInitial = false) {
                const $bg = $('<div class="hero-bg"></div>').css({
                    backgroundImage: `url('${url}')`,
                    opacity: isInitial ? 1 : 0,
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 0,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    transition: 'opacity 1s ease-in-out'
                });

                // Initial slides shouldn't animate
                if (isInitial) return $bg;

                // Force reflow to make opacity transition work
                $bg.appendTo($slider);
                setTimeout(() => $bg.css('opacity', 1), 50); 

                return $bg;
            }

            // Slide update
            function updateSlide(index) {
                index = (index + total) % total;

                // Use responsive sized images instead of full-size originals
                const isMobile = window.innerWidth < 576;
                const sizes = (images[index].sizes) || {};
                const url = (isMobile ? sizes['card-md-desktop'] : sizes['card-xl-desktop']) || images[index].url;

                // Capture the current backgrounds before appending the new one
                const $oldBgs = $slider.find('.hero-bg');
                const $lcpImg = $('#heroLcpImage');

                createSlideBackground(url);

                // After the new slide has faded in, remove the previous background
                // (including the PHP-rendered #heroLcpImage on the first transition)
                setTimeout(() => {
                    $oldBgs.remove();
                    $lcpImg.remove();
                }, 1100);

                // Indicators
                $('.slide-indicators button')
                    .removeClass('active')
                    .eq(index).addClass('active');

                currentIndex = index;
            }

            function startAutoSlide() {
                autoSlide = setInterval(() => updateSlide(currentIndex + 1), 5000);
            }

            function stopAutoSlide() {
                clearInterval(autoSlide);
            }

            // Initial Setup — first image is PHP-rendered as <picture id="heroLcpImage"> for LCP

            // Indicators
            const $indicators = $('.slide-indicators').empty();

            images.forEach((img, i) => {
                $('<button class="indicator"></button>')
                    .attr('data-slide', i)
                    .on('click', () => {
                        stopAutoSlide();
                        updateSlide(i);
                        startAutoSlide();
                    })
                    .appendTo($indicators);
            });

            $indicators.find('button').first().addClass('active');

            // Controls
            $('#prevSlide').on('click', () => {
                stopAutoSlide();
                updateSlide(currentIndex - 1);
                startAutoSlide();
            });

            $('#nextSlide').on('click', () => {
                stopAutoSlide();
                updateSlide(currentIndex + 1);
                startAutoSlide();
            });

            startAutoSlide();
        })();

    }

    // ------------------------------------------------------------
    //  TAX LOCATION — MOBILE READ MORE
    // ------------------------------------------------------------
    if ($('body').hasClass('tax-location') && $(window).width() < 576) {
        const $para = $('.location-intro');
        if (!$para.length) return;

        $para.addClass('clamped');

        $('<button>', {
            text: 'Read more +',
            class: 'read-more-btn btn btn-link mt-2',
            click: function () {
                const expanded = $para.toggleClass('clamped').hasClass('clamped');
                $(this).text(expanded ? 'Read more +' : 'Read less -');
            }
        }).insertAfter($para);
    }

});